import { Injectable } from '@angular/core';
import { PrescriptionModel } from '../../../models/master-data/prescription.model';
import { PrescriptionUrl } from '../../../shared/urls/master-data.prescription.url';
import { PrescriptionCategoryUrl } from '../../../shared/urls/master-data.prescription-category.url';
import { BaseService } from '../../../shared/services/base.service';
@Injectable()
export class PrescriptionService {
    constructor(public baseService: BaseService) {
    }


    updatePrescription(id, param) {
        let url = PrescriptionUrl.PRESCRIPTION_UPDATE + `${id}`;
        return this.baseService.update(url, param);
    }

    deletePrecription(id) {
        let url = PrescriptionUrl.PRESCRIPTION_DELETE.replace('{id}', id);
        return this.baseService.delete(url);
    }

    getWeekQuantityData(): any[] {
        return [
            {
                id: 0,
                name: 'Quantity'
            },
            {
                id: 1,
                name: 'Week'
            }
        ];
    }

    getDefunctData(): any[] {
        return [
            {
                id: 0,
                name: 'False'
            },
            {
                id: 1,
                name: 'True'
            }
        ];
    }

    getPrescriptionCategory(){
        const urlPrescriptionCategory = PrescriptionCategoryUrl.PRESCRIPTIONCATEGORY_GET_ALL;
        return this.baseService.getData(urlPrescriptionCategory);
    }

    getPrescriptionList(param){
        let urlPrescription = PrescriptionUrl.PRESCRIPTION_GET;
        return this.baseService.getData(urlPrescription, param);
    }

    getPrescription(id) {
        const url = PrescriptionUrl.PRESCRIPTION_DETAIL + `${id}`;
        return this.baseService.getData(url);
    }
    
    addPrescription(param){
        if(param) {
            param.defunct = parseInt(param.defunct, 0);
        }
        const url = PrescriptionUrl.PRESCRIPTION_ADD;
        return this.baseService.postData(url, param);
    }
}


// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/master-data/presciption/prescription.service.ts